import { LottieIcon } from "./LottieIcon";
import { SvgIcon } from "./SvgIcon";
import { IconProps } from "../types";

export const Icon = (props: IconProps) => (
  props.src.endsWith(".json") || props.src.endsWith(".lottie") ?<LottieIcon {...props} />: <SvgIcon {...props}/>
);
